import Tools from './tools';

export default class Nav {
    constructor() {
        // Nav

        this.OFFSET = 100;

        this.burger();
        this.sticky();

    }

    burger() {
        const btn = document.querySelector('.nav__burger');

        if (btn) {
            btn.addEventListener('click', () => {
                document.querySelector('.nav').classList.toggle('js-open');

                if (document.querySelector('.nav').classList.contains('js-open')) {
                    Tools.freezeScroll();
                } else {
                    Tools.freeScroll();
                }
            });
        }
    }

    sticky() {
        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= this.OFFSET) {
                document.querySelector('.nav').classList.add('js-sticky');
            } else {
                document.querySelector('.nav').classList.remove('js-sticky');
            }
        })
    }
}